var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPickUpMini = function SvgPickUpMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6236FF",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.46674,
    d: "M18 22v-3.333a.667.667 0 0 0-.666-.667h-2.667a.667.667 0 0 0-.667.667v3.334M19.85 14.874a.747.747 0 0 0-1.033 0 1.667 1.667 0 0 1-2.3 0 .747.747 0 0 0-1.033 0 1.667 1.667 0 0 1-2.301 0 .747.747 0 0 0-1.033 0 1.667 1.667 0 0 1-2.513-2.166l1.926-2.79a1.33 1.33 0 0 1 1.104-.585h6.667a1.33 1.33 0 0 1 1.102.582l1.93 2.795a1.667 1.667 0 0 1-2.516 2.163"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.46674,
    d: "M10.667 15.3v5.367A1.333 1.333 0 0 0 12 22.001h8a1.333 1.333 0 0 0 1.334-1.334V15.3"
  }))));
};
export default SvgPickUpMini;